import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 8.00488V3H1V8.00488L23 8.00488Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 9.99536H1V21L23 21V9.99536ZM7.00015 12.0835L10.4144 15.4977L7.00015 18.9119L5.58594 17.4977L7.58594 15.4977L5.58594 13.4977L7.00015 12.0835ZM12.0002 16.4977H18.0002L18.0002 18.4977H12.0002V16.4977Z"}}]};

const TerminalRectangle1Filled = Vue.extend<IconProps>({
  name: 'TerminalRectangle1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'terminal-rectangle-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TerminalRectangle1Filled;
